var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-5 mt-5"},[_c('FamiglieArticolo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }